module.exports = __webpack_public_path__ + "img/chr_ts_90_21_4.244f3f9b.png";